export default __webpack_public_path__ + "static/media/Next.f9d7edf8.svg";